export const FETCH_WAVELENGTH_EMPLOYEES = "FETCH_WAVELENGTH_EMPLOYEES"
export const RECEIVE_WAVELENGTH_EMPLOYEES = "RECEIVE_WAVELENGTH_EMPLOYEES"
export const ADD_WAVELENGTH_EMPLOYEE = "ADD_WAVELENGTH_EMPLOYEE"
export const DELETE_WAVELENGTH_EMPLOYEE = "DELETE_WAVELENGTH_EMPLOYEE"
export const DELETE_IP_ADDRESS = "DELETE_IP_ADDRESS"
export const ADD_IP_ADDRESS = "ADD_IP_ADDRESS"
export const RECEIVE_IP_ADDRESSES = "RECEIVE_IP_ADDRESSES"
export const FETCH_IP_ADDRESSES = "FETCH_IP_ADDRESSES"

export const fetchWavelengthEmployees = (success, error) => ({
  type: FETCH_WAVELENGTH_EMPLOYEES,
  success,
  error,
})

export const addWavelengthEmployee = (email, success, error) => ({
  type: ADD_WAVELENGTH_EMPLOYEE,
  email,
  success,
  error,
})

export const deleteWavelengthEmployee = (userId, success, error) => ({
  type: DELETE_WAVELENGTH_EMPLOYEE,
  userId,
  success,
  error,
})

export const receiveWavelengthEmployees = (response) => ({
  type: RECEIVE_WAVELENGTH_EMPLOYEES,
  response,
})

export const fetchIPAddresses = (success, error) => ({
  type: FETCH_IP_ADDRESSES,
  success,
  error,
})

export const addIPAddress = (params, success, error) => ({
  type: ADD_IP_ADDRESS,
  params,
  success,
  error,
})

export const deleteIPAddress = (ipId, success, error) => ({
  type: DELETE_IP_ADDRESS,
  ipId,
  success,
  error,
})

export const receiveIPAddresses = (response) => ({
  type: RECEIVE_IP_ADDRESSES,
  response,
})
